import { styled } from '@mui/material/styles'
import { SmallLinkContrastText, SmallText } from '../../styles/Typography.styled'
import { mobile } from '../../../utils/breakpoints'
import { Box } from '@mui/material'

export const RightContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  ${({ theme }) => mobile(theme, { 'align-items': 'center' })}
`

export const MaluLogoImage = styled('img')`
  width: 100px;
  ${({ theme }) => mobile(theme, { width: '90px' })}
`

export const MaluLogoLink = styled('a')`
  display: inline-flex;
  cursor: pointer;
`

export const TextCopyright = styled(SmallText)`
  color: ${({ theme }) => theme.palette.branding.footerText};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-wrap-mode: nowrap;
`

export const TextCopyrightLink = styled(SmallLinkContrastText)`
  text-align: right;
  color: ${({ theme }) => theme.palette.branding.footerText};

  &:hover {
    color: ${({ theme }) => theme.palette.branding.footerTextHover};
  }
`
